import L from 'leaflet';
import 'leaflet-rotatedmarker';
import HttpService from '../../providers/http-service.js';
import MarkerPopup from '../popup/marker-popup.js';
import Popup from '../../components/popup/popup.js';
import moment from 'moment';
import { getConfig } from '../../config';

export default class RouteMarker extends L.Marker {
    constructor(map, info, oid, allDistance, color) {
        super();
        this.map = map;
        this.httpService = new HttpService();
        this.color = color;
        this.path = '../../../Scripts/fort-map/dist/images/';
        this.oid = oid;
        this.type = 'route';
        this._latlng = this._getMarkerPosition(info.lat, info.lon);
        this.dt = info.tm;
        this.distance = info.dst;
        this.allDistance = allDistance;
        this.popup = null;
        this.direction = info.dir;
        this.config = getConfig();
        this.options.icon = this._getObjectIcon();
        this.setIconAngle(info.dir);
        this.on('click', (event) => !this.map.isClickBlocked() && this._onClickMarker(event));
    }

    _getObjectIcon() {
        let iconUrl = this.path + 'arrow-' + this.color + '.svg';
        return L.icon({
            iconUrl: iconUrl,
            iconAnchor: [this.config.routeMarker.anchorX, this.config.routeMarker.anchorY],
            iconSize: [this.config.routeMarker.width, this.config.routeMarker.heigth],
            className: 'route-marker'
        });
    }

    getWidthForColision() {
        return 13;
    }

    getHeightForColision() {
        return 13;
    }

    getMarginLeftForColision() {
        return -12;
    }

    getMarginTopForColision() {
        return -12;
    }

    _getMarkerPosition(lat, lon) {
        if ((lat > 90) || (lat < -90)) {
            return new L.LatLng(0, 0);
        }
        else
            return new L.LatLng(lat, lon);
    }

    _onClickMarker(e) {
        var date = new Date(this.dt);
        try {
            date.setMinutes(date.getMinutes() - timeZoneOffsetMinutes);
        }
        catch (err) {
            date.setMinutes(date.getMinutes());
        }
        var event = new CustomEvent('syncTrackDisplayData', { detail: { oid: this.oid, date: date } });
        document.dispatchEvent(event);
        this.httpService.getData('/objectinfo?oid=' + this.oid + '&dt=' + this.dt)
            .then(
                data => {
                    this._showPopup(data);
                },
                error => { }
            );
    }

    _showPopup(data) {
        let popupData = data.sensors || [];
        let title = data.Name;
        popupData.unshift({
            name: messages["dist_from_last_point"],
            val: this.getDistanceString(this.distance)
        });
        popupData.unshift({
            name: messages["dist_from_start_route"],
            val: this.getDistanceString(this.allDistance)
        });
        popupData.unshift({
            name: messages['Time'],
            ico: "last_connect.png",
            val: moment(fmtools.getLocalDateTime(data.dt))
                    .format(messages['moment_data_time_format'])
        });
        popupData.unshift({
            name: messages['IMEI'],
            val: data.IMEI
        });
        this.popup = new Popup(this.map, title, popupData, this.getLatLng());
        this.popup.show();
    }

    getDistanceString(dst) {
        var dst_str = dst + ' ' + messages["meter"];
        if (dst > 1000)
            dst_str = (dst / 1000).toFixed(1) + ' ' + messages["kilometer"];
        return dst_str;
    }
}
